import React, { useState, useRef, useEffect } from 'react';
import { ApiCore } from '../../../api/index';
import { withRouter } from 'react-router-dom';
import QRCode from 'qrcode.react';
import styles from './index.module.scss';
import warn from '../../../static/images_cso/warn.png';
import up_down_connect from '../../../static/images_cso/up_down_connect.png';
import plus_fold from '../../../static/images_cso/plus_fold.png';
import get_poster from '../../../static/images_cso/get_poster.png';
import fold_arrrow_down from '../../../static/images_cso//search/fold_arrrow_down.png';
import fold_cover from '../../../static/images_cso//search/fold_cover.png';
import fold_hospital from '../../../static/images_cso//search/fold_hospital.png';
import fold_title from '../../../static/images_cso//search/fold_title.png';
import icon_medicine_l_r from '../../../static/images_cso/icon_medicine_l_r.png';
import utils from '../../../utils/utils';
import { Toast, Button } from 'antd-mobile-v5';

const api = new ApiCore();

const env = process.env.REACT_APP_ENV;

const CovidSuggest = (props: any) => {

    const [wxUrl, setWxUrl] = useState('');
    const [drugs, setDrugs] = useState<any>([]);
    const [planCode, setPlanCode] = useState<any>('');
    const [drugState, setDrugState] = useState<any>('');
    const [flowCode, setFlowCode] = useState<any>('');
    const [treatmentPlanCode, setTreatmentPlanCode] = useState<any>('');
    const [showPoster, setShowPoster] = useState<any>(false);
    const [imgUrl, setImgUrl] = useState<any>('');
    const [sourceType, setSourceType] = useState<any>('');
    const [strategyName, setStrategyName] = useState<any>('');
    const [aliasName, setAliasName] = useState<any>('');
    const [needAliasName, setNeedAliasName] = useState<any>('');
    const [orderDrug, setOrderDrug] = useState<any>({});
    const [orderDrugs, setOrderDrugs] = useState<any>({});
    const [orderPlanCode, setOrderPlanCode] = useState<any>('');
    const [orderSingleDrug, setOrderSingleDrug] = useState<any>(''); // 是否计入产品选购（多药品处方购买）
    const [isExpand, setIsExpand] = useState<any>(true);
    const [needFold, setNeedFold] = useState<any>(false);
    const [channelType, setChannelType] = useState<any>();
    const [isOutbound, setIsOutbound] = useState<any>(false); // 是否境外

    useEffect(() => {
        document.title = '甄选产品包';
        initCondition()
        initData();
        return () => {
        }
    }, [])

    const initCondition = () => {
        let savedUrlParam = localStorage.getItem('OriginUrlParam');
        if (savedUrlParam) {
            let savedOriginUrlParam: any = {};
            try {
                savedOriginUrlParam = JSON.parse(savedUrlParam)
            } catch (error) {
                savedOriginUrlParam = {};
            }
            let _from = savedOriginUrlParam.from;
            // 自然人进入才折叠
            // if (_from === 'csoDoctorFreeLogin') {
            //     setNeedFold(true);
            //     setIsExpand(false);
            // }
        }
    }

    const initData = async () => {
        let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
        const doctorInfo: any = JSON.parse(doctor_info);
        let urlParams = utils.getUrlParams();
        let projectCode = urlParams.projectCode || '';
        let treatmentPlanCode = urlParams.code || '';
        let needAliasName = urlParams.needAliasName || '';
        let channelType = urlParams.channelType || '';

        setNeedAliasName(needAliasName);
        setTreatmentPlanCode(treatmentPlanCode);
        setChannelType(channelType);
        getInfo().then((data: any) => {
            let _planCode = data.planCode;
            if (!treatmentPlanCode) {
                treatmentPlanCode = _planCode;
                setTreatmentPlanCode(_planCode);
            }
            return api.getDoctorFlowGenerate({
                context: {
                    planCode: '',
                    doctorCode: doctorInfo.code,
                    projectCode: projectCode || doctorInfo.projects[0]?.code,
                    treatmentPlanCode: _planCode
                },
                type: 'DrugOrder' // InvitePatient -> 绑定患者, DrugOrder -> 买药 
            }).then((res: any) => Object.assign(res, { state: data.state}))
        }).then(async (result: any) => {
            const drugState = result.state;
            setDrugState(drugState);
            // state 1: 预购, state: 2 在售
            if (result.code == 0) {
                const _flowCode = result.data || '';
                setFlowCode(result.data);
                let jumpUrl = '';
                const sourceData = await getSourceData(treatmentPlanCode);
                // const sourceType = sourceData?.channel?.wxAppId == 'wxfcf0410b76abcfa1' ? 'xiaohui' : 'gaoji';
                // const sourceType = (sourceData?.channel?.strategyName == 'xiaohui') ? 'xiaohui' : 'gaoji';
                const sourceType = sourceData?.channel?.strategyName || '';
                const strategyName = sourceData?.channel?.strategyName || '';
                const aliasName = sourceData?.channel?.strategyName == 'jingdong' ? (sourceData?.drugs[0]?.aliasName || '') : '';
                const orderDrug = sourceData?.channel?.strategyName == 'jingdong' ? (sourceData?.drugs ? sourceData?.drugs[0] : {}) : {};
                const orderPlanCode = sourceData.planCode;
                const orderSingleDrug = sourceData.singleDrug
                const outTargetUrl = sourceData.outTargetUrl;
                const isOutbound = sourceData.isOutbound;
                setOrderDrug(orderDrug);
                setOrderDrugs(sourceData?.drugs || []);
                setSourceType(sourceType);
                setStrategyName(strategyName);
                setAliasName(aliasName);
                setOrderPlanCode(orderPlanCode);
                setOrderSingleDrug(orderSingleDrug);
                setIsOutbound(isOutbound);
                if (env === 'production') {
                    // 生产环境用普通链接（只对生产有效）
                    jumpUrl = `https://edc-saas.huimeihealth.com.cn/urllink/cso/patient?flowCode=${_flowCode}&flowType=DrugOrder&tenantCode=${localStorage.getItem('tenantCode') || ''}&sourceType=${sourceType}&drugState=${drugState}&strategyName=${strategyName}&aliasName=${needAliasName ? (encodeURIComponent(aliasName || '') || '') : ''}&planCode=${orderPlanCode}&drugName=${(encodeURIComponent(orderDrug.name || '') || '')}&drugType=${(orderDrug.type || '')}&singleDrug=${orderSingleDrug || ''}`;
                    setWxUrl(jumpUrl);
                } 
                // else if (isOutbound) {
                //     const suRes: any = await api.getProjectSupplier({
                //         tenantCode: localStorage.getItem('tenantCode') || '',
                //         doctorCode: doctorInfo.code
                //     });
                //     if (suRes && suRes.code == 0) {
                //         const suData = suRes.data || {};
                //         jumpUrl = `http://yfw.yaoxielink.com/home.html?qrcode_code=${outTargetUrl || ''}&userid=${doctorInfo.code || ''}`;
                //         setWxUrl(jumpUrl);
                //     } else {
                //         jumpUrl = `http://yfw.yaoxielink.com/home.html?qrcode_code=${outTargetUrl || ''}&userid=${doctorInfo.code || ''}`;
                //         setWxUrl(jumpUrl);
                //     }
                // }
                else {
                    // jumpUrl = `https://edc-saas-test.huimeimt.com/urllink/cso/patient?flowCode=${_flowCode}`;
                    // 测试环境生成urlLink
                    getWxMiniProgramUrl(_flowCode, sourceType, drugState, strategyName, aliasName, needAliasName, orderDrug, orderPlanCode, orderSingleDrug);
                }
            }
        });
    }

  // 获取小程序id和跳转路径
  const getSourceData = async (treatmentPlanCode: string) => {
    const parmas = {};
    const res: any = await api.getTreatmentPlanDetail(treatmentPlanCode);
    if (res.code == 0) {
    //   const data = res.data || {};
    //   const channel = data.channel;
    //   return channel.wxAppId == 'wxfcf0410b76abcfa1' ? 'xiaohui' : 'gaoji' // 小惠商城
      return res.data || {};
    }
    return {};
  }

    const getInfo = () => {
        return new Promise((resolve, reject) => {
            let urlParams = utils.getUrlParams();
            let code = urlParams.code || '';
            let projectCode = urlParams.projectCode || '';
            let ApiRequest = api.getPlanDetail;
            if (!code) {
                let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
                const doctorInfo: any = JSON.parse(doctor_info);
                code = projectCode || doctorInfo.projects[0]?.code;
                ApiRequest = api.getPlanRecommendDetail;
            }
            code && ApiRequest({
                code: code,
            }).then((res: any) => {
                if (res.code == 0) {
                    const _data = res.data || {};
                    console.log(' _data ', _data);
                    setDrugs(_data.drugs || []);
                    setPlanCode(_data.planCode);
                    setShowPoster(_data.showPoster);
                    resolve(_data);
                }
            });
        })
    }

    const getWxMiniProgramUrl = (flowCode: string, sourceType: string, drugState: string, strategyName: string, aliasName: string, needAliasName: any, orderDrug: any, orderPlanCode: any, orderSingleDrug: any) => {
        let doctor_info = sessionStorage.getItem('cso_doctor_info') || '{}';
        const doctorInfo: any = JSON.parse(doctor_info);
        return new Promise<void>((resolve) => {
            let envVersion = 'release';
            // 开发环境 开发版
            if (env === 'development') {
                envVersion = 'trial'; // develop
            }
            // 测试环境 体验版
            else if (env === 'test') {
                envVersion = 'trial';
            }
            // 生产环境 正式版
            else if (env === 'production') {
                envVersion = 'release';
            }
            api.apiAppSecretGenerateUrl({// getAppSecretScheme
                appCode: 'CSO_PT',
                envVersion: envVersion,
                path: 'pages/index/index',
                query: `flowCode=${flowCode}&doctorCode=${doctorInfo.code}&flowType=DrugOrder&tenantCode=${localStorage.getItem('tenantCode') || ''}&sourceType=${sourceType}&drugState=${drugState}&strategyName=${strategyName}&aliasName=${needAliasName ? (encodeURIComponent(aliasName || '') || '') : ''}&planCode=${orderPlanCode}&drugName=${(encodeURIComponent(orderDrug.name || '') || '')}&drugType=${(orderDrug.type || '')}&singleDrug=${orderSingleDrug || ''}`,
            }).then((res: any) => {
                if (res.code == 0) {
                    let _data = res.data || '';
                    setWxUrl(_data);
                }
                resolve();
            });
        });
    }

    const updateQRcode = () => {
        if (env !== 'production' && !isOutbound) {
            getWxMiniProgramUrl(flowCode, sourceType, drugState, strategyName, aliasName, needAliasName, orderDrug, orderPlanCode, orderSingleDrug);
        }
    }
    
    const getPoster = () => {
        if (utils.isMiniProgram()) {
            (window as any).wx.miniProgram.navigateTo({
                url: `/pages/prescriptionPoster/prescriptionPoster?treatmentPlanCode=${treatmentPlanCode}&url=${encodeURIComponent(wxUrl)}`,
                success: function (e: any) {
                },
                fail: function (e: any) {
                }
            })
        }
        // 放置于小程序中生成海报
        // api.generateTreatmentPlanPoster({
        //     "treatmentPlanCode": treatmentPlanCode,
        //     "url": wxUrl
        // }).then((res: any) => {
        //     if (res.code == 0) {
        //         setImgUrl(res.data);
        //     }
        // });
    }

    const toDetail = () => {
        sessionStorage.setItem('multiMedicineListDrugs', JSON.stringify(orderDrugs));
        props.history.push('/cso/doctor/multiMedicineList');
    }

    const toExpand = () => {
        setIsExpand(!isExpand);
    }

    return (
        <div className={styles.covid_content}>
            <div className={styles.top}>
            </div>
            <div className={styles.down}>
                <img className={styles.icon_medicine_l_r} src={icon_medicine_l_r} alt="" />
                <div className={styles.down_content}>
                    <div className={styles.d_t}>——  扫描<div className={styles.d_t_l}>「</div>二维码<div className={styles.d_t_r}>」</div>选购  ——</div>
                    <div className={styles.d_m}>
                        <div className={styles.qr_bg_wrap_outer}>
                            <div className={styles.qr_bg_wrap} onClick={updateQRcode}>
                                {
                                    wxUrl ?
                                    <QRCode
                                        id="covid_suggest_qr"
                                        className={styles.qr_code_img_content}
                                        value={wxUrl}  //value参数为生成二维码的链接
                                        size={165} //二维码的宽高尺寸
                                        fgColor="#000000"  //二维码的颜色
                                    />
                                    :
                                    <div className={styles.qr_placeholder}></div>
                                }
                            </div>
                        </div>
                    </div>
                    <div className={styles.d_d}>请使用微信进行扫码</div>
                </div>
            </div>
            <div className={styles.bottom}>
                {/* <div className={styles.bottom_up_wrap}>
                    <Button className={styles.bottom_up}>保存到本地</Button>
                </div> */}
                <div className={styles.bottom_down_wrap}>
                    <Button className={styles.bottom_down} onClick={() => { toDetail() }}>查看所有甄选产品</Button>
                </div>
            </div>
            {
                showPoster && 
                <div className={styles.get_poster}>
                    <div className={styles.btn_poster} onClick={getPoster}>
                        <img src={get_poster} alt="" />
                        <span>生成海报</span>
                    </div>
                </div>
            }
            <div className={styles.in_bottom}></div>
        </div>
    )
}

export default withRouter(CovidSuggest);